import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["unitInput", "unitButton"]

  connect() {
    if (!["C", "F"].includes(this.unitInputTarget.value)) {
      this.unitInputTarget.value = "C"
    }
    this.syncUnitButtons()
  }

  chooseUnit(event) {
    event.preventDefault()
    const unit = event.currentTarget.dataset.value
    if (!["C", "F"].includes(unit)) return

    this.unitInputTarget.value = unit
    this.syncUnitButtons()
  }

  syncUnitButtons() {
    const selected = this.unitInputTarget.value
    this.unitButtonTargets.forEach((button) => {
      const active = button.dataset.value === selected
      button.classList.toggle("ui-segment-btn-active", active)
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })
  }
}
